import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SalienteLibrarySharedModule } from "@saliente/library";
import { ClientFormsService } from "../client-forms.service";
import { MicroProfitFormComponent } from "./micro-profit-form.component";

@NgModule({
    imports: [
		CommonModule, FormsModule, SalienteLibrarySharedModule
	],
	providers: [
		ClientFormsService
	],
	declarations: [
		MicroProfitFormComponent,
	],
	exports: [
		MicroProfitFormComponent
	]
})
export class MicroProfitSharedModule { }